<template>
  <div class="">
    <BlockShortcuts/>
    <MyHeader @toggle-sidebar="toggleSidebar"/>
    <MySidebar :collapsed="collapsed"/>
    <div class="container-fluid container-main" :class="{logged: $store.getters.getLoggedIn}">
      <MessageModal 
        :message="$store.state.message" 
        :messageType="$store.state.messageType" 
        :redirectRoute="$store.state.redirectRoute"
        @close="resetMessage" 
      />
      <CustomConfirm ref="customConfirm" />
      <router-view/>
    </div>
  </div>
</template>

<script>
import BlockShortcuts from '@/components/BlockShortCuts/BlockShortCuts.vue';
import MyHeader from '@/components/MyHeader.vue';
import MySidebar from '@/components/MySidebar.vue';
import MessageModal from '@/components/MessageModal.vue';
import CustomConfirm from "@/components/CustomConfirm.vue";

export default {
  components: {
    MyHeader,
    MySidebar,
    MessageModal,
    CustomConfirm,
    BlockShortcuts
  },
  data(){
    return{
      collapsed: false,
      inactivityTimeout: null,
      inactivityLimit: parseInt(process.env.VUE_APP_LOGOUT_TIMER) * 60 * 1000
    }
  },
  methods: {
    resetMessage() {
      this.$store.dispatch('closeMessage');
    },
    toggleSidebar() {
      this.collapsed = !this.collapsed;
    },
    checkIfMobile() {
      this.collapsed = this.$store.getters.isMobile;
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimeout);
      this.inactivityTimeout = setTimeout(() => {
        this.forceLogout();
      }, this.inactivityLimit);
    },
    async forceLogout() {
      const user = this.$store.getters.getUser
      if(user.ignore_logout_time) return;
      if (this.$route.path === '/login') return;

      const countdown = parseInt(process.env.VUE_APP_LOGOUT_TIMER_BEFORE);
      let current = countdown;
      let confirmed = false;

      const getMessage = () =>
        `Você está inativo. Será desconectado em ${current} segundos, confirme para continuar na tela.`;

      this.$refs.customConfirm.message = getMessage();
      const confirmPromise = this.$refs.customConfirm.open();

      const interval = setInterval(() => {
        current--;

        this.$refs.customConfirm.message = getMessage();

        if (current <= 0 && !confirmed) {
          clearInterval(interval);
          this.$store.dispatch('logout');

        }
      }, 1000);

      try {
        confirmed = await confirmPromise;
      } catch (err) {
        clearInterval(interval);
        this.$store.dispatch('logout');
      }

      clearInterval(interval);

      if (confirmed) {
        this.resetInactivityTimer();
      }
    },
    setupInactivityListeners() {
      const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, this.resetInactivityTimer);
      });
      this.resetInactivityTimer();
    },
    removeInactivityListeners() {
      const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
      events.forEach(event => {
        window.removeEventListener(event, this.resetInactivityTimer);
      });
      clearTimeout(this.inactivityTimeout);
    },
    blockCopyShortcut(e) {
      if (e.ctrlKey && e.key.toLowerCase() === 'c') {
        e.preventDefault()
        this.$store.dispatch('setModalMessage', {
          message: "Atalho Ctrl + C foi bloqueado nesta página.",
          type: "warn",
        });
      }
    }
  },
  mounted(){
    this.checkIfMobile();
    this.$store.commit('setCustomConfirm', this.$refs.customConfirm);
    if (this.$store.getters.getLoggedIn) {
      this.setupInactivityListeners();
    }
  },
  beforeUnmount() {
    this.removeInactivityListeners();
  },
  watch: {
    $route() {
      if (this.$store.getters.isMobile) {
        this.collapsed = true;
      }
    },
    '$store.getters.getLoggedIn'(val) {
      if (val) {
        this.setupInactivityListeners();
      } else {
        this.removeInactivityListeners();
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/main.scss";
</style>
